import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
    standalone: false,
    templateUrl: "./horizontalCheckbox.component.html",
})
export class FormlyHorizontalCheckbox extends FieldType<FieldTypeConfig> {
    styleClass: string;

    ngOnInit() {
        if (this.props.disabled) this.styleClass = "disabled form-control";
        else this.styleClass = "form-control";
    }

    selectionMade() {
        if (this.props.change) this.props.change(this);
    }
}
